module.exports = __webpack_public_path__ + "img/柚子5.6af4734b.png";